import React, { FC } from 'react';
import { hot } from 'react-hot-loader/root';

import { Loaders, QueryManager } from 'components';
import { useAuth } from 'hooks';
import { useGetCurrentUserFeedQuery } from 'api';
import { USER_DISABLED } from 'features/auth/constants';
import Logout from './Logout';

import Providers from './Providers';

const ProtectedIndex: FC = ({ children }) => {
  const auth = useAuth();
  const variables = { user_id: auth.data.id };

  const queryResult = useGetCurrentUserFeedQuery({ variables });

  return (
    <QueryManager loader={<Loaders.StandardNoHeader />} {...queryResult}>
      {({ data, error }) => {
        if (error?.message === USER_DISABLED) {
          return <Logout />;
        } else if (!data?.getByUserFeed) {
          throw new Error();
        }

        return <Providers queryResult={queryResult}>{children}</Providers>;
      }}
    </QueryManager>
  );
};

export default hot(ProtectedIndex);
